import React from "react";
import "./Button.scss";
import Icon from "../Icon";
import Spinner from "../Spinner";

export default function Button({ text, color, backgroundColor, onSubmit, leftIcon, loading, className }) {
  return (
    <button className={className ? "c-main-btn " + className : "c-main-btn"} style={{ backgroundColor: backgroundColor ? backgroundColor : "#FFC415" }} onClick={onSubmit} disabled={loading}>
      <div className="c-left-btn-content">
        {leftIcon && (
          <div className="c-social-icon">
            <Icon icon={leftIcon ? leftIcon : "arrow"} size={22} />
          </div>
        )}
        <p style={color ? { color: color } : { color: "#443712" }}>{text ? text : "Enter"}</p>
      </div>

      <div className="c-icon-bg">{loading ? <Spinner color={color ? color : "#443712"} /> : <Icon color={color ? color : "#443712"} icon="arrow" size={10} />}</div>
    </button>
  );
}
